import {Layout} from 'antd';
import styles from "./app_layout.module.css";
import HeaderComponent from "../components/header/header_component";
import FooterComponent from "../components/footer/footer_component";
import Loader from "../components/loader/loader";
import {useApp} from "../context/AppDataContext";
import {useEffect} from "react";

const {Header, Content, Footer} = Layout;

export default function AppLayout({children}) {
    const {isLoading} = useApp();
    return (
        <>
            {isLoading && <Loader/>}
            <Layout>
                <Header className={styles.header}>
                    <HeaderComponent/>
                </Header>
                <Content className={styles.content}>
                    {children}
                </Content>
                <Footer className={styles.footer}>
                    <FooterComponent/>
                </Footer>
            </Layout>
        </>
    )
}